import {
  GET_BUSSINESS_DASHBOARD_BY_REGION_REQUEST,
  GET_BUSSINESS_DASHBOARD_BY_REGION_SUCCESS,
  GET_BUSSINESS_DASHBOARD_BY_REGION_ERROR,
} from "../actions/types";

export const bussinessDashboardByRegion = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_BUSSINESS_DASHBOARD_BY_REGION_REQUEST:
      return {
        loading: true,
      };
    case GET_BUSSINESS_DASHBOARD_BY_REGION_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_BUSSINESS_DASHBOARD_BY_REGION_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
